<script>
import regions from './data.js';

export default {
  name: 'CountrySelect',
  props: {
    country: String,
    countryName: Boolean,
    whiteList: Array,
    blackList: Array,
    className: String,
    shortCodeDropdown: Boolean,
    topCountry: {
      type: String,
      default: 'United States',
    },
    placeholder: {
      type: String,
      default: 'Select Country',
    },
    disablePlaceholder: {
      type: Boolean,
      default: false,
    },
    removePlaceholder: {
      type: Boolean,
      default: false,
    },
    usei18n: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedCountry: this.country, // Local copy of the `country` prop
    };
  },
  computed: {
    countries() {
      let countryList = regions.filter((region) => {
        if (this.countryName) {
          return region.countryName !== this.topCountry;
        } else {
          return region.countryShortCode !== this.topCountry;
        }
      });
      countryList.unshift({
        countryName: this.countryName ? this.topCountry : undefined,
        countryShortCode: !this.countryName ? this.topCountry : undefined,
      });

      if (this.whiteList) {
        countryList = countryList.filter((country) =>
          this.whiteList.includes(country.countryShortCode),
        );
      }

      if (this.blackList) {
        countryList = countryList.filter(
          (country) => !this.blackList.includes(country.countryShortCode),
        );
      }

      return countryList;
    },
  },
  watch: {
    // Keep local data in sync with the prop
    country(newVal) {
      this.selectedCountry = newVal;
    },
  },
  methods: {
    onChangeCountry(value) {
      this.$emit('update:modelValue', value);
    },
  },
};
</script>

<template>
  <v-select
    v-model="selectedCountry"
    :items="
      countries.map((region) => ({
        title: shortCodeDropdown ? region.countryShortCode : region.countryName,
        value: countryName ? region.countryName : region.countryShortCode,
      }))
    "
    :label="placeholder"
    :class="className"
    :menu-props="{ closeOnContentClick: false }"
    :clearable="!disablePlaceholder"
    @update:modelValue="onChangeCountry">
  </v-select>
</template>
